import React, { useCallback, useMemo } from 'react'
import { useSideBarContext } from '../context/SidebarContext';
import { Calendar, ChartLine, CircleHelp, Headphones, LayoutDashboard, NotebookText, Settings, ShieldHalf, Users, Volume2 } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {

    const location = useLocation();

    const { isSidebarHidden, toggleSidebar } = useSideBarContext();

    const sidebarClass = useMemo(() => `side-navbar ${isSidebarHidden ? 'side-hide' : ''}`, [isSidebarHidden]);

    const isActive = useCallback((path) => location.pathname === path ? 'active' : '', [location.pathname]);

    return (
        <div className={sidebarClass}>
            <button className="closeBtn" onClick={toggleSidebar}><i className="fa-solid fa-times" /> </button>
            <div className="sidebar-logo">
                <a className="logo h3 text-black text-decoration-none fw-semibold" href="#">
                    <img src="/assets/images/Logo_transparent.png" alt="Logo" />
                    {/* Match Mate */}
                </a>
            </div>
            <div className="side_menu_wrapper">
                <div className="sidemenu_list">
                    {/* <span className="nvx">
                        <span className="nvx_text">Navigation</span>
                        <span className="nvx_dots">...</span>
                    </span> */}
                    <ul className="nav flex-column position-relative" id="sidebar-nav">
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard')}`} to={'/admin-dashboard'}><span className="menu-icon"><LayoutDashboard /></span><span className="menu_text">Dashboard</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/user-management')}`} to={'/admin-dashboard/user-management'}><span className="menu-icon"><Users /></span><span className="menu_text">User Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/content-management')}`} to={'/admin-dashboard/content-management'}><span className="menu-icon"><NotebookText /></span><span className="menu_text">Content Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/event-and-challenge-management')}`} to={'/admin-dashboard/event-and-challenge-management'}><span className="menu-icon"><Calendar /></span><span className="menu_text">Event & Challenge Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/announcement-management')}`} to={'/admin-dashboard/announcement-management'}><span className="menu-icon"><Volume2 /></span><span className="menu_text">Announcement Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/analytics-management')}`} to={'/admin-dashboard/analytics-management'}><span className="menu-icon"><ChartLine /></span><span className="menu_text">Analytics Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/role-and-permission-management')}`} to={'/admin-dashboard/role-and-permission-management'}><span className="menu-icon"><ShieldHalf /></span><span className="menu_text">Role & Permission Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/support-management')}`} to={'/admin-dashboard/support-management'}><span className="menu-icon"><Headphones /></span><span className="menu_text">Support Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/faq-management')}`} to={'/admin-dashboard/faq-management'}><span className="menu-icon"><CircleHelp /></span><span className="menu_text">FAQ Management</span></Link>
                        </li>
                        <li className="sidebar-link">
                            <Link className={`nav-link ${isActive('/admin-dashboard/settings-and-log-management')}`} to={'/admin-dashboard/settings-and-log-management'}><span className="menu-icon"><Settings /></span><span className="menu_text">Settings & Log Management</span></Link>
                        </li>
                        {/* <li className="sidebar-link">
                            <a className="nav-link" data-bs-toggle="collapse" href="#navTimeManagement" role="button" aria-expanded="false" aria-controls="collapseExample"><span className="menu-icon"><i data-lucide="history" /></span><span className="menu_text">Time Management</span></a>
                            <div className="collapse" id="navTimeManagement" data-bs-parent="#sidebar-nav">
                                <ul className="sub-menu-list">
                                    <li>
                                        <a href="time-management.html">Home</a>
                                    </li>
                                    <li>
                                        <a href="user-activity.html">Activity</a>
                                    </li>
                                    <li>
                                        <a href="projects.html">Projects</a>
                                    </li>
                                    <li>
                                        <a href="project-analytics.html">Project Analytics</a>
                                    </li>
                                    <li>
                                        <a href="time-tracking.html">Time Tracking</a>
                                    </li>
                                    <li>
                                        <a href="timesheet.html">Time Sheet</a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" data-bs-toggle="collapse" href="#navInstallation" role="button" aria-expanded="false" aria-controls="collapseExample"><span className="menu-icon"><i className="hgi hgi-stroke hgi-installing-updates-02" /></span><span className="menu_text">Installation</span></a>
                            <div className="collapse" id="navInstallation" data-bs-parent="#sidebar-nav">
                                <ul className="sub-menu-list">
                                    <li>
                                        <a href="installation-reporting.html">Reporting</a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" href="customers.html"><span className="menu-icon"><i data-lucide="users" /></span><span className="menu_text">Customers</span></a>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" data-bs-toggle="collapse" href="#navInspections" role="button" aria-expanded="false" aria-controls="collapseExample"><span className="menu-icon"><i data-lucide="file-search" /></span><span className="menu_text">Inspections</span></a>
                            <div className="collapse" id="navInspections" data-bs-parent="#sidebar-nav">
                                <ul className="sub-menu-list">
                                    <li>
                                        <a href="inspection-request.html">Request</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">Reporting</a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" data-bs-toggle="collapse" href="#navServiceWO" role="button" aria-expanded="false" aria-controls="collapseExample"><span className="menu-icon"><i className="hgi hgi-stroke hgi-work-history" /></span><span className="menu_text">Services/Work Order</span></a>
                            <div className="collapse" id="navServiceWO" data-bs-parent="#sidebar-nav">
                                <ul className="sub-menu-list">
                                    <li>
                                        <a href="add-work.html">Add Work</a>
                                    </li>
                                    <li>
                                        <a href="emergency.html">Emergency </a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" data-bs-toggle="collapse" href="#navHR" role="button" aria-expanded="false" aria-controls="collapseExample"><span className="menu-icon"><i data-lucide="user" /></span><span className="menu_text">HR</span></a>
                            <div className="collapse" id="navHR" data-bs-parent="#sidebar-nav">
                                <ul className="sub-menu-list">
                                    <li>
                                        <a href="javascript:void(0)">Expenses</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">Schedule List</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">Time Off</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">Office Chat</a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" href="safety-meeting.html"><span className="menu-icon"><i data-lucide="shield-alert" /></span><span className="menu_text">24x7 Safety Meeting</span></a>
                        </li> */}
                        {/* <li className="sidebar-link">
                            <a className="nav-link" href="users.html"><span className="menu-icon"><i data-lucide="users" /></span><span className="menu_text">Users</span></a>
                        </li> */}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Sidebar